import { getRequest, postRequest } from "../../utils/axios";

export const loginApi = (formData) => postRequest("/auth/login", formData);

export const logoutApi = () => postRequest("/auth/logout");

export const signupApi = (formData) => postRequest("/auth/signup", formData);

export const cookieLoginApi = () => getRequest("/auth/login");
